const initHighchartsMulticolor = (Highcharts) => {
  const symbols =
    Highcharts &&
    Highcharts.SVGRenderer &&
    Highcharts.SVGRenderer.prototype &&
    Highcharts.SVGRenderer.prototype.symbols;

  if (!symbols) {
    return;
  }

  if (!symbols.rectangle && symbols.rect) {
    symbols.rectangle = symbols.rect;
  }

  if (Highcharts.__multicolorSeriesInitialized) {
    return;
  }

  try {
    require("highcharts-multicolor-series")(Highcharts);
    Highcharts.__multicolorSeriesInitialized = true;
  } catch (err) {
    Highcharts.__multicolorSeriesInitialized = false;
  }
};

export default initHighchartsMulticolor;
